import { render, staticRenderFns } from "./u-select.vue?vue&type=template&id=2f620ff7&"
import script from "./u-select.vue?vue&type=script&lang=js&"
export * from "./u-select.vue?vue&type=script&lang=js&"
import style0 from "./u-select.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports